import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  membresiasList,
  membresiasListSelectBox,
  membresiaCreate, 
  membresiaRead 
} = actions;

const membresiasListListAction = ( id = '') => {

  return async dispatch => {
    try {  
      const response = await DataService.get('/membresiasPaciente/list.php?idPaciente=' + id );      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(membresiasList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const membresiasListSelectBoxAction = (paramBusqueda = '') => {

  return async dispatch => {
    try {                                
      const response = await DataService.get('/catalogos/membresias/list.php?paramBusqueda='+ paramBusqueda);      
      
      if (response.status === 200 && response.data.data) {       
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre + ' $' + el.precio_base };
        });

        dispatch(membresiasListSelectBox(registrosList));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const membresiaCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/membresiasPaciente/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const membresiaReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/membresia/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(membresiaRead(response.data.data));
          return true;
        }
      } else {
        dispatch(membresiaRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  membresiasListListAction,
  membresiasListSelectBoxAction,
  membresiaCreateAction,    
  membresiaReadAction,    
};
